// extracted by mini-css-extract-plugin
export default {"container":"ForWhom_container__3cjOg","containerSmall":"ForWhom_containerSmall__FyuuR","content":"ForWhom_content__TVh6c","contentItem":"ForWhom_contentItem__y7gX9"};